module.exports = __webpack_public_path__ + "fonts/OpenSans-Light.846a12c.ttf";